export { default as chalk_play } from './chalk_play.gif';
export { default as cukoo_clock } from './cukoo_clock.gif';
export { default as hey_plane } from './hey_plane.gif';
export { default as hooray_banner } from './hooray_banner.gif';
